module.exports = __webpack_public_path__ + "media/icons/gallery-prev-50f6fcea.png";